<template>
  <div class="container">
    <div class="container mb-2">    
    <!-- <v-divider class="mx-4" color="black"></v-divider> -->
    <h1 class="text-center display-3 font-weight-thin mt-2 mb-2">Tea</h1>
    <!-- <v-divider class="mx-4" color="black"></v-divider> -->
    </div>
    <!-- <backtowarmegetraenke></backtowarmegetraenke> -->
    <v-card class="mt-2">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          color="green"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="breakfast"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import Backtowarmegetraenke from './Backtowarmegetraenke.vue';
export default {
  // components: { Backtowarmegetraenke },
  name: 'Tee',
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Tee',
          value: 'speise',
        },
        { text: 'Preis', value: 'preis' },
      ],
      breakfast: [
        {
          id: 1,
          speise: 'Earl Grey',
          preis: '5,90 €',
        },
        {
          id: 2,
          speise: 'Grüner Tee | green tea',
          preis: '5,90 €',
        },
        {
          id: 3,
          speise: 'Kräutertee | herbal tea',
          preis: '5,90 €',
        },
        {
          id: 4,
          speise: 'Kamillentee | chamomile tea',
          preis: '5,90 €',
        },
        {
          id: 5,
          speise: 'Früchtetee | fruit tea',
          preis: '5,90 €',
        },
        {
          id: 6,
          speise: 'Pfefferminztee | mint tea',
          preis: '5,90 €',
        },
        {
          id: 7,
          speise: 'Heiße Zitrone | hot lemonade',
          preis: '3,10 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
